const apiConfig = {
  baseUrl: 'https://api.themoviedb.org/3/',
  apiKey: process.env.REACT_APP_API_KEY,
  originalImage: (imgPath) => `${imgPath}`,
  w500Image: (imgPath) => `${imgPath}`,
};

export default apiConfig;
